import { apiEndpoint, requestPayload, isNull } from '../utils/common';
import { API, ERRORS } from '../constant';
import { validateBin } from '../utils/validations';
import { post } from '../utils/http';

/**
 * Card details based on card number.
 *
 * @param {string} bin - Card number
 * @param {boolean} isEmi - true if emi related data required
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function cardDetails(bin, isEmi) {
  if (!validateBin(bin)) {
    return Promise.reject(new Error(ERRORS.BIN));
  }

  isEmi = !isNull(isEmi) ? isEmi : false;
  bin = bin.toString();
  return post.call(this, apiEndpoint(API.BIN), requestPayload({ bin, isEMIDetail: isEmi }));
}

/**
 * Card details based on card number.
 *
 * @param {string} url - request url
 * @param {object} payload - request payload
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function directApi(url, payload, skipMiddleware = true) {
  return new Promise((resolve, reject) => {
    post
      .call(this, url, payload, skipMiddleware)
      .then(data => {
        if (
          data &&
          data.body &&
          data.body.resultInfo &&
          data.body.resultInfo.resultStatus === 'S'
        ) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/card.js